import React, {useState, useEffect} from 'react';
import './SegmentationPage.css';
import { observer } from 'mobx-react'
import Sidebar from '../../components/sidebar/index.js';
import Sidebar_new from '../../components/sidebar_for_user/index.js';
import logoBig from '../../assets/logo-big.svg'
import Segment_new from '../../components/segmentation_new/index.js'

import Mini from '../../components/mini/index.js'

import Dataset from '../../components/dataset/index.js'
// import PopupaddWorkspace from '../../components/segmentation/popupAddWorkspace.js';
// import PopupaddSegmentation from '../../components/segmentation/baket/popupAddSegmentation.js';
import GlobalState from "../../stores/GlobalState.js";
import PopupAddDataset from '../../components/dataset/popup/popupAddDataset.js';
import PopupAttachment from '../../components/dataset/popup/popupAttachment.js';
import PopupDeployment from '../../components/dataset/backet/popupDeployment.js';
import PopupaddSegment from '../../components/segmentation/popup/popupAddSegment.js'
import PopupDeleteColumn from '../../components/segmentation/popup/popupDeleteColumn.js'
import PopupDeleteClause from '../../components/segmentation/baket/popupDeleteClause.js'
import PopupDeleteShedule from '../../components/segmentation/popup/popupDeleteShedule.js'
import PopupDeleteTable from '../../components/segmentation/popup/popupDeleteTable.js'
import PopupCloseSelectAttribute from '../../components/segmentation/popup/popupCloseSelectAttribute.js'
import PopupCloseEditDeploy from '../../components/segmentation/popup/popupCloseEditDeploy.js'
import PopupCloseShedule from '../../components/segmentation/popup/popupCloseShedule.js'




import PopupDeleteWorkspace from '../../components/segmentation/baket/popupDeleteWorkspace.js';
import {Helmet} from "react-helmet";
import Beta from '../../components/Beta/index.js';
import UserPool from '../../components/autorize/UserPool.js';

const Segmentation = observer(() => {
    const [holdBlock, setholdBlock] = useState(true);
    const [datasegment, setDatasegment] = useState(1);
    const [user, setUser]=useState("");
    const changemenu = () =>{
        setholdBlock(false)
    }
    window.onbeforeunload = () => {
        setholdBlock(true)
    }
    const token = localStorage.getItem("token");
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const cognitoUser = UserPool.getCurrentUser();
            setUser(cognitoUser.username)
        } 
    }, []);
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    return (
        <>
            {
                langmenu=="de"?
                <Helmet>
                    <title>Beinf.ai — Mikrosegmentierung der Kundenbasis</title>
                    <meta name="description" content="Beinf.ai — Mikrosegmentierung basierend auf der Vorhersage des Kundenverhaltens durch Machine Learning: persönliche Empfehlungen, Kaufwahrscheinlichkeit, Abwanderungsrisiko und mehr." />
                </Helmet>
                :
                <Helmet>
                    <title>Beinf.ai — Customer Base Micro-segmentation</title>
                    <meta name="description" content="Beinf.ai — Micro-segmentation based on customer behavior prediction using Machine Learning: personalized recommendations, purchase propensity, churn risk, and more." />
                </Helmet>
            }
            {
            
                user=="admin"|| user=="gewgur"?
                <>
                    <Sidebar_new/>
                </>
                :
                <>
                    <Sidebar/>
                </>
            }
            {
            
             user=="admin"||
            user=="test_team_2"||
            user=="dev_1"||
            user=="gewgur"||
            user=="test_team_3"||
            user=="test_team_4"||
            user=="test"||
            user=="m.bahmat"||
            user=="k.zaporozhchenko"||
            user=="m.tsvyd"||
            user=="DemoBG"||
            user=="Demo_acc_BG"||
            user=="a.hryhorian"||
            user=="DemoBindGenius"||
            user=="d.tarasenko@beinf.ai"||
            user=="tempuser"||
            user=="case_1"||
            user=="case_2"||
            user=="case_4"||
            user=="v.cherdak@taluno.ai"||
            user=="ikm@taluno.ai"||
            user=="case_3"?
            <>
                
                <div className="segmentation hold">
                
                    <div className='body_segment'>
                        {GlobalState.numbersubmenu===1?<Segment_new/>:<Dataset/>}
                    </div>
                </div>
                <Mini/>
                {/* {GlobalState.ispopupaddworkspaceShow?<PopupaddWorkspace />:<></>} */}
                {/* {GlobalState.ispopupaddSegmentationShow?<PopupaddSegmentation/>:<></>} */}
                {GlobalState.ispopupaddSegmentShow?<PopupaddSegment/>:<></>}
                {GlobalState.ispopupadddatasetShow?<PopupAddDataset/>:<></>}
                {GlobalState.ispopupaddAttachmentShow?<PopupAttachment/>:<></>}
                {GlobalState.ispopupDeploymentShow?<PopupDeployment/>:<></>}
                {GlobalState.ispopupdeleteWorkspaceShow?<PopupDeleteWorkspace/>:<></>}
                {GlobalState.ispopupdeleteColumnShow?<PopupDeleteColumn/>:<></>}
                {GlobalState.ispopupdeleteSheduleShow?<PopupDeleteShedule/>:<></>}
                {GlobalState.ispopupdeleteClauseShow?<PopupDeleteClause/>:<></>}
                {GlobalState.ispopupdeleteTableShow?<PopupDeleteTable/>:<></>}
                {GlobalState.ispopupcloseselectattributeShow?<PopupCloseSelectAttribute/>:<></>}
                {GlobalState.ispopupcloseEditDeployShow?<PopupCloseEditDeploy/>:<></>}
                {GlobalState.ispopupcloseSheduleShow?<PopupCloseShedule/>:<></>}
            </>
            :
            <div className="main-page">
                <Beta/>
            </div>
        }
        </>
    );
})

export default Segmentation;

